type IArquivos = {
    arquivo: any;
    nome: string;
};

type ISubPasta = {
    titleSubPasta: string;
    arquivos?: IArquivos[];
    subPastas?: ISubPasta[];
};

type IMaterial = {
    isPaste?: boolean;
    titlePaste?: string;
    arquivos?: IArquivos[];
    subPastas?: ISubPasta[];
};
type TItem = {
    title: string;
    materiais: IMaterial[];
};

export const ListMateriasSeLigaPlanoAnual: TItem[] = [
    {
        title: 'Avaliação Formativa',
        materiais: [
            {
                subPastas: [
                    {
                        titleSubPasta: 'Língua Portuguesa',
                        arquivos: [
                            {
                                nome: 'Orientacao_para_aplicacao_e_correcao_das_provas_SeLiga_LP',
                                arquivo:
                                    'SeLiga_Materiais_2026/AVALIAÇÃO FORMATIVA/LÍNGUA PORTUGUESA/Orientacao_para_aplicacao_e_correcao_das_provas_SeLiga_LP.pdf',
                            },
                            {
                                nome: 'Quadro_habilidades_Avaliação_1_SL_LP',
                                arquivo: 'SeLiga_Materiais_2026/AVALIAÇÃO FORMATIVA/LÍNGUA PORTUGUESA/Quadro_habilidades_Avaliação_1_SL_LP.pdf',
                            },
                            {
                                nome: 'Quadro_habilidades_Avaliação_2_SL_LP',
                                arquivo: 'SeLiga_Materiais_2026/AVALIAÇÃO FORMATIVA/LÍNGUA PORTUGUESA/Quadro_habilidades_Avaliação_2_SL_LP.pdf',
                            },
                            {
                                nome: 'SE LIGA_LP-PROVA 1',
                                arquivo: 'SeLiga_Materiais_2026/AVALIAÇÃO FORMATIVA/LÍNGUA PORTUGUESA/SE LIGA_LP-PROVA 1.pdf',
                            },
                            {
                                nome: 'SE LIGA_LP-PROVA 2',
                                arquivo: 'SeLiga_Materiais_2026/AVALIAÇÃO FORMATIVA/LÍNGUA PORTUGUESA/SE LIGA_LP-PROVA 2.pdf',
                            },
                        ],
                    },
                    // {
                    //     titleSubPasta: 'Matemática',
                    //     arquivos: [
                    //         {
                    //             nome: 'Orientacao_para_aplicacao_e_correcao_das_provas_SeLiga_MAT',
                    //             arquivo:
                    //                 'SeLiga_Materiais_2026/AVALIAÇÃO FORMATIVA/MATEMÁTICA/Orientacao_para_aplicacao_e_correcao_das_provas_SeLiga_MAT.pdf',
                    //         },
                    //         {
                    //             nome: 'Quadro_habilidades_Avaliação_1_SL_MAT',
                    //             arquivo: 'SeLiga_Materiais_2026/AVALIAÇÃO FORMATIVA/MATEMÁTICA/Quadro_habilidades_Avaliação_1_SL_MAT.pdf',
                    //         },
                    //         {
                    //             nome: 'Quadro_habilidades_Avaliação_2_SL_MAT',
                    //             arquivo: 'SeLiga_Materiais_2026/AVALIAÇÃO FORMATIVA/MATEMÁTICA/Quadro_habilidades_Avaliação_2_SL_MAT.pdf',
                    //         },
                    //         {
                    //             nome: 'SE_LIGA_MAT-PROVA 1',
                    //             arquivo: 'SeLiga_Materiais_2026/AVALIAÇÃO FORMATIVA/MATEMÁTICA/SE_LIGA_MAT-PROVA 1.pdf',
                    //         },
                    //         {
                    //             nome: 'SE_LIGA_MAT-PROVA 2',
                    //             arquivo: 'SeLiga_Materiais_2026/AVALIAÇÃO FORMATIVA/MATEMÁTICA/SE_LIGA_MAT-PROVA 2.pdf',
                    //         },
                    //     ],
                    // },
                ],
            },
        ],
    },
    {
        title: 'Materiais Didáticos',
        materiais: [
            {
                subPastas: [
                    {
                        titleSubPasta: 'Língua Portuguesa',
                        subPastas: [
                            {
                                titleSubPasta: 'Livro Aluno',
                                arquivos: [
                                    {
                                        nome: 'SL_LP_Aluno',
                                        arquivo: 'SeLiga_Materiais_2026/MATERIAIS DIDÁTICOS/LÍNGUA PORTUGUESA/LIVRO ALUNO/SL_LP_Aluno.pdf',
                                    },
                                ],
                            },
                        ],
                    },
                    // {
                    //     titleSubPasta: 'Livro Professor - LP e Matemática',
                    //     arquivos: [
                    //         {
                    //             nome: 'SL_LivroProfessor_MP',
                    //             arquivo:
                    //                 's3://plataformaestruturante/general_files/SeLiga_Materiais_2026/MATERIAIS DIDÁTICOS/LIVRO PROFESSOR - LP E MATEMÁTICA/SL_LivroProfessor_MP.pdf',
                    //         },
                    //     ],
                    // },
                    // {
                    //     titleSubPasta: 'Matemática',
                    //     subPastas: [
                    //         {
                    //             titleSubPasta: 'Livro Aluno',
                    //             arquivos: [
                    //                 {
                    //                     nome: 'SL_Mat_Aluno',
                    //                     arquivo: 'SeLiga_Materiais_2026/MATERIAIS DIDÁTICOS/MATEMÁTICA/LIVRO ALUNO/SL_Mat_Aluno.pdf',
                    //                 },
                    //             ],
                    //         },
                    //     ],
                    // },
                ],
            },
        ],
    },
    {
        title: 'Teste Diagnóstico',
        materiais: [
            {
                subPastas: [
                    {
                        titleSubPasta: 'Língua Portuguesa',
                        arquivos: [
                            {
                                nome: 'Orientacao Teste Diagnostico_ SL e AB 2023_alfabetização',
                                arquivo:
                                    'SeLiga_Materiais_2026/TESTE DIAGNÓSTICO/LÍNGUA PORTUGUESA/Orientacao Teste Diagnostico_ SL e AB 2023_alfabetização.pdf',
                            },
                            {
                                nome: 'Teste Diagnostico de alfabetizacao _SL e AB',
                                arquivo:
                                    'SeLiga_Materiais_2026/TESTE DIAGNÓSTICO/LÍNGUA PORTUGUESA/Teste Diagnostico de alfabetizacao _SL e AB.pdf',
                            },
                        ],
                    },
                    // {
                    //     titleSubPasta: 'Matemática',
                    //     arquivos: [
                    //         {
                    //             nome: 'Orientacao Teste Diagnostico_ SL e AB 2023_matemática',
                    //             arquivo:
                    //                 'SeLiga_Materiais_2026/TESTE DIAGNÓSTICO/MATEMÁTICA/Orientacao Teste Diagnostico_ SL e AB 2023_matemática.pdf',
                    //         },
                    //         {
                    //             nome: 'Teste Diagnostico de matemática _SL e AB',
                    //             arquivo: 'SeLiga_Materiais_2026/TESTE DIAGNÓSTICO/MATEMÁTICA/Teste Diagnostico de matemática _SL e AB.pdf',
                    //         },
                    //     ],
                    // },
                ],
            },
        ],
    },
    {
        title: 'Visão Geral - Subsídio - Sistemática de Acompanhamento',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'Se Liga_Subsídios',
                        arquivo: 'SeLiga_Materiais_2026/VISÃO GERAL- SUBSÍDIO - SISTEMÁTICA DE ACOMPANHAMENTO/Se Liga_Subsídios.pdf',
                    },
                    {
                        nome: 'SeLiga_Acelera_SISTEMATICA_DE_ACOMPANHAMENTO',
                        arquivo:
                            'SeLiga_Materiais_2026/VISÃO GERAL- SUBSÍDIO - SISTEMÁTICA DE ACOMPANHAMENTO/SeLiga_Acelera_SISTEMATICA_DE_ACOMPANHAMENTO.pdf',
                    },
                    {
                        nome: 'Visão Geral_Se Liga',
                        arquivo: 'SeLiga_Materiais_2026/VISÃO GERAL- SUBSÍDIO - SISTEMÁTICA DE ACOMPANHAMENTO/Visão Geral_Se Liga.pdf',
                    },
                ],
                subPastas: [
                    {
                        titleSubPasta: 'Cartazes',
                        arquivos: [
                            {
                                nome: 'AB_SL_cartaz_ACOMPANHAMENTO LIVROS LIDOS',
                                arquivo:
                                    'SeLiga_Materiais_2026/VISÃO GERAL- SUBSÍDIO - SISTEMÁTICA DE ACOMPANHAMENTO/Cartazes/AB_SL_cartaz_ACOMPANHAMENTO LIVROS LIDOS.pdf',
                            },
                            {
                                nome: 'AB_SL_cartaz_ACOMPANHAMENTO MENSAL I A',
                                arquivo:
                                    'SeLiga_Materiais_2026/VISÃO GERAL- SUBSÍDIO - SISTEMÁTICA DE ACOMPANHAMENTO/Cartazes/AB_SL_cartaz_ACOMPANHAMENTO MENSAL I A.pdf',
                            },
                        ],
                    },
                    {
                        titleSubPasta: 'Relatórios Qualitativos',
                        arquivos: [
                            {
                                nome: 'SeLiga_Acelera_Relatorio_A',
                                arquivo:
                                    'SeLiga_Materiais_2026/VISÃO GERAL- SUBSÍDIO - SISTEMÁTICA DE ACOMPANHAMENTO/Relatórios Qualitativos/SeLiga_Acelera_Relatorio_A.pdf',
                            },
                            {
                                nome: 'SeLiga_Acelera_Relatorio_B',
                                arquivo:
                                    'SeLiga_Materiais_2026/VISÃO GERAL- SUBSÍDIO - SISTEMÁTICA DE ACOMPANHAMENTO/Relatórios Qualitativos/SeLiga_Acelera_Relatorio_B.pdf',
                            },
                            {
                                nome: 'SeLiga_Acelera_Relatorio_C',
                                arquivo:
                                    'SeLiga_Materiais_2026/VISÃO GERAL- SUBSÍDIO - SISTEMÁTICA DE ACOMPANHAMENTO/Relatórios Qualitativos/SeLiga_Acelera_Relatorio_C.pdf',
                            },
                        ],
                    },
                    {
                        titleSubPasta: 'Tabelas',
                        arquivos: [
                            {
                                nome: 'AB_SL_tabela_PERFIL TURMA I',
                                arquivo:
                                    'SeLiga_Materiais_2026/VISÃO GERAL- SUBSÍDIO - SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/AB_SL_tabela_PERFIL TURMA I.pdf',
                            },
                            {
                                nome: 'AB_SL_tabela_PERFIL TURMA II',
                                arquivo:
                                    'SeLiga_Materiais_2026/VISÃO GERAL- SUBSÍDIO - SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/AB_SL_tabela_PERFIL TURMA II.pdf',
                            },
                            {
                                nome: 'AB_SL_tabela_RESULTADO FINAL I',
                                arquivo:
                                    'SeLiga_Materiais_2026/VISÃO GERAL- SUBSÍDIO - SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/AB_SL_tabela_RESULTADO FINAL I.pdf',
                            },
                            {
                                nome: 'AB_SL_tabela_RESULTADO FINAL II',
                                arquivo:
                                    'SeLiga_Materiais_2026/VISÃO GERAL- SUBSÍDIO - SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/AB_SL_tabela_RESULTADO FINAL II.pdf',
                            },
                            {
                                nome: 'SL_tabela_ACOMPANHAMENTO MENSAL I B',
                                arquivo:
                                    'SeLiga_Materiais_2026/VISÃO GERAL- SUBSÍDIO - SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/SL_tabela_ACOMPANHAMENTO MENSAL I B.pdf',
                            },
                            {
                                nome: 'SL_tabela_ACOMPANHAMENTO MENSAL II A',
                                arquivo:
                                    'SeLiga_Materiais_2026/VISÃO GERAL- SUBSÍDIO - SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/SL_tabela_ACOMPANHAMENTO MENSAL II A.pdf',
                            },
                        ],
                    },
                ],
            },
        ],
    },
];
